import { ECS } from '../state';
import { randomInRange } from '~/helpers/MathUtils';
import { urls } from '@/config/assets';
import { beerConfig } from '@/config/games/beer';
import { randomIntRange, randomSign } from '~/helpers/MathUtils';
import sample from 'lodash/sample';
import { getUrlBoolean } from '~/helpers/UrlParam';
import { createContext, useContext } from 'react';

const debug = getUrlBoolean('debug');

const TextureContext = createContext();

export const Endings = () => {
  // useEffect(() => {
  //   addEndings(0, 0);
  // }, []);

  const [
    //
    t_shed,
    t_sign,
    t_tractor,
    t_pub,
    t_person,
  ] = useAsset([
    //
    urls.t_shed,
    urls.t_sign,
    urls.t_tractor,
    urls.t_pub,
    urls.t_person,
  ]);

  const textures = {
    shed: t_shed,
    sign: t_sign,
    tractor: t_tractor,
    pub: t_pub,
    person: t_person,
  };

  return (
    <>
      <TextureContext.Provider value={textures}>
        <ECS.Entities
          in={endings}
          children={Ending}
        />
      </TextureContext.Provider>
    </>
  );
};

export const Ending = (entity) => {
  const textures = useContext(TextureContext);
  const texture = textures[entity.type];

  return (
    <ECS.Entity entity={entity}>
      <ECS.Component name="three">
        <group>
          {debug && (
            <group>
              <mesh position={[0, entity.size[1] * 0.5, 0]}>
                <planeGeometry args={[entity.size[0], entity.size[1]]} />
                <meshBasicMaterial
                  color="red"
                  transparent
                  opacity={0.2}
                />
              </mesh>
              <mesh position={[0, 0, 0]}>
                <sphereGeometry args={[0.05]} />
                <meshBasicMaterial
                  color="red"
                  transparent
                  opacity={0.5}
                />
              </mesh>
            </group>
          )}

          <mesh
            position={[
              entity.offset[0],
              entity.offset[1] + entity.size[1] * 0.5,
              entity.offset[2] + 0.01,
            ]}
          >
            <planeGeometry args={[entity.size[0], entity.size[1]]} />
            <meshBasicMaterial
              map={texture}
              alphaTest={0.5}
            />
          </mesh>
        </group>
      </ECS.Component>
    </ECS.Entity>
  );
};

export const clearEndings = () => {
  ECS.world.remove(endings);
};

export const addEndings = (areaIdx, x = 0) => {
  const area = beerConfig.areas[areaIdx];

  for (let idx = 0; idx < area.endings.length; idx++) {
    const item = area.endings[idx];
    addEnding(
      x + idx * 1.5,
      0,
      0,
      ...item.size,
      item.type,
      item.offset,
      idx == area.endings.length - 1
    );
  }
};

export const addEnding = (
  x = 0,
  y = 0,
  z = 0,
  width = 2,
  height = 2,
  type = 'sign',
  offset,
  isLast
) => {
  const opts = {
    isEnding: true,
    position: { x, y, z },
    offset,
    size: [width, height, 1],
    type,
  };
  if (isLast) {
    opts.isLast = true;
  }

  ECS.world.add(opts);
};
